<template>
  <div :class="[$style.container, { [$style.active]: item.active }]" @click="handleClick">
    <div :class="$style.content">
      <div v-if="$slots.hasOwnProperty('icon')" :class="$style.icon">
        <slot name="icon" />
      </div>

      <div>
        <p :class="$style.title">{{ item.title }}</p>
        <p :class="$style.description">{{ item.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectablingPanel',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClick() {
      if (this.item.active) {
        return;
      }

      this.$emit('click', this.item);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    background: #fff
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    border-radius: 5px

    &:hover
      background: linear-gradient(249.76deg, #37b55e -8.32%, #7bd3ff 108.85%), #fff
      cursor: pointer

    &.active
      background: linear-gradient(249.76deg, #37b55e -8.32%, #7bd3ff 108.85%), #fff

      &:hover
        cursor: default

  .content
    display: flex
    align-items: center
    padding: 20px

  .icon
    margin-right: 20px

  .title
    +base-text
    color: #212121

  .description
    +base-text
    color: #212121
    opacity: 0.5
</style>
